import { Dispatch, SetStateAction } from 'react'
import { ValidationApiError } from '../types/ApiError'

export const paymentErrorHandler = (
    error: any,
    setError: (field: string, message: string) => void,
    setParentError: (field: string, message: string) => void,
    setPaymentError: Dispatch<SetStateAction<boolean>>,
): void => {
    if (error instanceof ValidationApiError) {
        const validationError = error as ValidationApiError

        Object.keys(validationError.fields).forEach(fieldPath => {
            const fieldName = fieldPath.split('.').pop() as string
            const message = validationError.fields[fieldPath].message

            setError(fieldName, message)
            setParentError(fieldName, message)
        })
    } else {
        setPaymentError(true)
    }
}
